import React from "react";
import { useSelector } from "react-redux";

import { i18, trb } from "@utilities";
import { RadioFormField } from "@components/FormField/HookFormFields";
import { FullWidthInputWrapper, StepperFormRow } from "@components";
import { selectPaymentsByCashOptions, selectPaymentsByCryptoOptions } from "@redux";

export const ClientPaymentForServices = ({ control }) => {
  const paymentsByCashOptions = useSelector(selectPaymentsByCashOptions);
  const paymentsByCryptoOptions = useSelector(selectPaymentsByCryptoOptions);

  return (
    <StepperFormRow>
      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientPaymentForServises.0.data.clientPaymCash"
          title={trb(i18.Labels.ClientPaymCash)}
          options={paymentsByCashOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>

      <FullWidthInputWrapper>
        <RadioFormField
          control={control}
          name="clientPaymentForServises.0.data.clientPaymCryp"
          title={trb(i18.Labels.ClientPaymCryp)}
          options={paymentsByCryptoOptions}
          optionsLabel="label"
          optionsValue="value"
          inline
        />
      </FullWidthInputWrapper>
    </StepperFormRow>
  );
};
